import axios from "axios";

// Use relative URL to leverage Vite proxy
const API_BASE_URL = '/api/v1';

export const createCustomerSessionDetails = async (sessionData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/customer-session-details`,
            sessionData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error creating customer session detail:", error);
        throw error.response?.data || { error: "Failed to create session detail" };
    }
};
export const markSessionMusicCompleted = async (sessionId) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/customer-session-details/${sessionId}/music-completed`
        );
        return response.data;
    } catch (error) {
        console.error("❌ Error marking session complete:", error);
        throw error.response?.data || { error: "Failed to mark session complete" };
    }
};

export const getCustomerSessionDetails = async (sessionId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/customer-session-details/${sessionId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching customer session details:", error);
        throw error;
    }
};

export const validatePin = async (pin) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/validate-pin`, { pin });
        return response.data;
    } catch (error) {
        console.error("Error validating PIN:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const getCustomerSessionDetailsByCustomerId = async (customerId) => {
    try {
        const res = await axios.get(
            `${API_BASE_URL}/customer-session-details/customer/${customerId}`
        );
        return res.data;
    } catch (err) {
        console.error("Error fetching session details:", err);
        throw err;
    }
};

export const createCustomerPostvital = async (postvitalData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/customer-postvital`,
            postvitalData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating customer postvital:", error);
        throw error.response ? error.response.data : error;
    }
}